import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useNavigate } from 'react-router-dom';
import { useImpersonation } from '../../contexts/ImpersonationContext';
import { AlertTriangle, X } from 'lucide-react';
export function ImpersonationBanner() {
    const { impersonated, stopImpersonation } = useImpersonation();
    const navigate = useNavigate();
    if (!impersonated)
        return null;
    const handleStop = () => {
        stopImpersonation();
        navigate('/super-admin');
    };
    return (_jsxs("div", { className: "print:hidden bg-amber-500 text-white px-6 py-2.5 flex items-center justify-between text-sm", children: [_jsxs("div", { className: "flex items-center gap-2", children: [_jsx(AlertTriangle, { size: 16 }), _jsx("span", { className: "font-semibold", children: "Mode assistance :" }), _jsxs("span", { children: ["vous agissez sur la commune ", _jsx("strong", { children: impersonated.name })] })] }), _jsxs("button", { onClick: handleStop, className: "flex items-center gap-1.5 px-3 py-1 rounded-lg bg-white/20 hover:bg-white/30 text-xs font-semibold", children: [_jsx(X, { size: 14 }), "Quitter"] })] }));
}
